import {pxToEm, coloredScrollBar} from "utils/styles/style_helpers";

export default theme =>({
    adstxt:{

        maxWidth: pxToEm(1400),
        width: '100%',
        '& .name-sites-indicator':{
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            '& .name-sites':{
                '& .searchabledropdown':{
                    width: pxToEm(310),
                    zIndex: '2' // make sure this sits over the ads txt stuff
                }
            },
            '& .adstxt-indicator':{
                marginBottom: pxToEm(14)
            }
        },
        '& .name-adstxt-values':{
            position: 'relative',
            height: pxToEm(236),
            width: '100%',
            marginTop: pxToEm(10),
            overflow: 'auto',
            overflowX: 'hidden',
            extend: coloredScrollBar(theme.color.primary.medium.swatch),
            '& .backdrop':{
                position: 'relative',
                zIndex: 1,
                background: theme.color.supporting.light.swatch,
                '& .highlighted-values':{
                    display: 'flex',
                    flexDirection: 'column',
                    // width: pxToEm(960),
                    padding: `${pxToEm(19)} ${pxToEm(9)}`,
                    fontSize: pxToEm(16),
                    pointerEvents: 'none',
                    '& mark':{
                        width: 'fit-content',
                        fontSize: pxToEm(14.9),
                        '&.missing':{
                            background: theme.color.attention.medium.swatch,
                            color: theme.color.attention.medium.swatch
                        },
                        '&.present':{
                            background: theme.color.supporting.light.swatch,
                            color: theme.color.supporting.light.swatch
                        }
                    }
                },
                '& .field':{
                    position: 'absolute',
                    top: 0,
                    height: '100%',
                    '&.isActive-true':{
                        '& .formelement':{
                            border: 'none !important' //this removes the blue border when field is active
                            }
                        },
                    '& .formelement':{
                        marginTop: pxToEm(8),
                        width: pxToEm(960),
                        height: '100%',
                        background: 'transparent',
                        border: 'none !important', //this prevents a slight shift in the form element when switching to active and removing border
                        '& .element':{
                            height: '100%',
                            '& textarea':{
                                display: 'block',
                                position: 'absolute',
                                height: '100%',
                                width: pxToEm(960),
                                zIndex: 2,
                                overflow: 'auto',
                                resize: 'none'
                            }
                        }

                    }
                },

                /// loading state
                '&.loading-true':{
                    height: pxToEm(236)
                }
            }
        },
        '& .name-adstxt-ctas':{
            width: '100%',
            marginTop: pxToEm(14),
            justifyContent: 'space-between',
        }
    }
})